import React, { useEffect, useMemo, useState } from "react";
import "./style.scss";
import { IconSearch, SearchUser, TimesIcon } from "~misc/icons";
import { Spinner } from "@chakra-ui/react";
import { useBuscaOnline } from "~pages/Wallet/hooks/useWallet";

function SearchSelect({ setCliente, setClientes }) {
  const [internalValue, setInternalValue] = useState("");
  const [buscaValue, setBuscaValue] = useState("");

  const enabled = useMemo(() => {
    if (buscaValue) return true;
    return false;
  }, [buscaValue])

  const buscas = useBuscaOnline(buscaValue, enabled);
  const loading = buscas.isFetching || buscas.isRefetching;

const pathname = window.location.pathname;
const keyStorage = `${pathname}-listagem`;

const keyEnter = (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    setBuscaValue(internalValue);
    setCliente(null);
    localStorage.setItem(keyStorage, internalValue);
  }
};

const handleSearch = (e) => {
  e.preventDefault();
  setBuscaValue(internalValue);
  setCliente(null);
  localStorage.setItem(keyStorage, internalValue);
};


useEffect(() => {
  const pathname = window.location.pathname;
  const keyStorage = `${pathname}-listagem`;
  const storedValue = localStorage.getItem(keyStorage);
  if (storedValue) {
    setInternalValue(storedValue);
    setBuscaValue(storedValue);
  }
}, []);

  const handleChange = (e) => {
    const inputValue = e.target.value;
    setInternalValue(inputValue);
  };

  useEffect(() => {
    if (buscas.data) {
      if (buscas.data.length === 1) setCliente(buscas.data[0])
      else setClientes(buscas.data)
    }
  }, [buscas.data])

  return (
   <>
     <div className="grid grid-cols-5 gap-4 container bg-white p-5 border-terciaria border rounded-b-lg border-t-0">
      <div className="col-span-4 relative SearchSelect">
        <label className="search-label">
          {
            loading
              ? <Spinner className="absolute top-[35%] left-[10px] z-10 w-[23px] h-[23px]" />
              : <SearchUser />
          }
          <input
            className="input-search w-full py-5 px-10 rounded-lg  border border-solid border-gray-300  placeholder-primaria text-16"
            type="text"
            value={internalValue}
            placeholder={"Buscar Cliente por Código Emissor ou Razão Social/Nome"}
            onChange={(e) => handleChange(e)}
            onKeyDown={keyEnter}
          />
          {internalValue && (
          <button
            type="button"
            className="absolute right-[10px] top-[29%] z-10 text-gray-500 hover:text-gray-700"
            onClick={() => {
              setInternalValue("");
              setBuscaValue("");
              setCliente(null);
              setClientes([]);
              localStorage.removeItem(keyStorage);
            }}
          >
             <TimesIcon />
          </button>
        )}
        </label>
      </div>
      <button
        className="col-span-1 button-search flex py-5 px-5 bg-primaria text-white rounded-lg gap-3 font-bold text-lg justify-center items-center"
        onClick={handleSearch}
      >
        Buscar
        <IconSearch fill="#FFF" className="w-4 md:ml-0 ml-2" />
      </button>
    </div>
    {buscas?.data?.isSuccess === false && (
      <p className="bg-red-100 text-red-700 border border-red-500 px-4 py-2 rounded-md mt-8 container">
        {buscas?.data?.message}
      </p>
    )}
   </>
  );
}

export default SearchSelect;
